"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountCharsetTypes = exports.graphemesAccount = exports.trimAccountSuffix = exports.isSubAccount = exports.toRecordExtended = exports.accountIdHex = exports.toHashedStyle = exports.toDottedStyle = exports.isSupportedAccount = void 0;
const blake2b_1 = __importDefault(require("blake2b"));
const common_1 = require("./common");
const grapheme_splitter_1 = __importDefault(require("grapheme-splitter"));
const emoji_list_json_1 = __importDefault(require("./char_set/emoji_list.json"));
const digit_list_json_1 = __importDefault(require("./char_set/digit_list.json"));
const en_list_json_1 = __importDefault(require("./char_set/en_list.json"));
const tr_list_json_1 = __importDefault(require("./char_set/tr_list.json"));
const th_list_json_1 = __importDefault(require("./char_set/th_list.json"));
const ko_list_json_1 = __importDefault(require("./char_set/ko_list.json"));
const vi_list_json_1 = __importDefault(require("./char_set/vi_list.json"));
const const_1 = require("../const");
function isSupportedAccount(account) {
    return /.+\.bit/.test(account) && account.split(/.#/).every(v => Boolean(v.length));
}
exports.isSupportedAccount = isSupportedAccount;
function toDottedStyle(inputAccount) {
    if (!isSupportedAccount(inputAccount)) {
        return inputAccount;
    }
    if (!inputAccount.includes('#')) {
        return inputAccount;
    }
    const [account, suffix] = inputAccount.split('.');
    const [main, sub] = account.split('#');
    return `${sub}.${main}.${suffix}`;
}
exports.toDottedStyle = toDottedStyle;
function toHashedStyle(inputAccount) {
    if (!isSupportedAccount(inputAccount)) {
        return inputAccount;
    }
    if (inputAccount.includes('#')) {
        return inputAccount;
    }
    const parts = inputAccount.split('.');
    if (parts.length === 3) {
        const [sub, main, suffix] = parts;
        return `${main}#${sub}.${suffix}`;
    }
    return inputAccount;
}
exports.toHashedStyle = toHashedStyle;
function accountIdHex(account) {
    const personal = Buffer.from('ckb-default-hash');
    const accountBuf = Buffer.from(account);
    const hasher = (0, blake2b_1.default)(32, null, null, personal);
    hasher.update(accountBuf);
    const hashBuffer = hasher.digest('binary');
    const first20Bytes = Buffer.from(hashBuffer.slice(0, 20));
    return (0, common_1.pad0x)(first20Bytes.toString('hex'));
}
exports.accountIdHex = accountIdHex;
function toRecordExtended(record) {
    return Object.assign(Object.assign({}, record), { type: record.key.split('.')[0], subtype: record.key.split('.')[1] });
}
exports.toRecordExtended = toRecordExtended;
function isSubAccount(account) {
    return account.split('.').length >= 3;
}
exports.isSubAccount = isSubAccount;
function trimAccountSuffix(account) {
    return account.replace(/\.bit$/, '');
}
exports.trimAccountSuffix = trimAccountSuffix;
function graphemesAccount(account, addSuffix = false, language = 'en') {
    const splitter = new grapheme_splitter_1.default();
    const split = splitter.splitGraphemes(account);
    const englishSplitArr = split.map((char) => {
        let _charType = const_1.CHAR_TYPE.unknown;
        if (emoji_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.emoji;
        }
        else if (digit_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.number;
        }
        else if (en_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.english;
        }
        return {
            char_set_name: _charType,
            char
        };
    });
    const turkishSplitArr = split.map((char) => {
        let _charType = const_1.CHAR_TYPE.unknown;
        if (emoji_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.emoji;
        }
        else if (digit_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.number;
        }
        else if (tr_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.turkish;
        }
        return {
            char_set_name: _charType,
            char
        };
    });
    const vietnameseSplitArr = split.map((char) => {
        let _charType = const_1.CHAR_TYPE.unknown;
        if (emoji_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.emoji;
        }
        else if (digit_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.number;
        }
        else if (vi_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.vietnamese;
        }
        return {
            char_set_name: _charType,
            char
        };
    });
    const thaiSplitArr = split.map((char) => {
        let _charType = const_1.CHAR_TYPE.unknown;
        if (emoji_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.emoji;
        }
        else if (digit_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.number;
        }
        else if (th_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.thai;
        }
        return {
            char_set_name: _charType,
            char
        };
    });
    const koreanSplitArr = split.map((char) => {
        let _charType = const_1.CHAR_TYPE.unknown;
        if (emoji_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.emoji;
        }
        else if (digit_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.number;
        }
        else if (ko_list_json_1.default.includes(char)) {
            _charType = const_1.CHAR_TYPE.korean;
        }
        return {
            char_set_name: _charType,
            char
        };
    });
    const englishUnknownChar = englishSplitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    const turkishUnknownChar = turkishSplitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    const vietnameseUnknownChar = vietnameseSplitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    const thaiUnknownChar = thaiSplitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    const koreanUnknownChar = koreanSplitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    let splitArr = null;
    if (!englishUnknownChar) {
        splitArr = englishSplitArr;
    }
    else if (!turkishUnknownChar) {
        splitArr = turkishSplitArr;
    }
    else if (!vietnameseUnknownChar) {
        splitArr = vietnameseSplitArr;
    }
    else if (!thaiUnknownChar) {
        splitArr = thaiSplitArr;
    }
    else if (!koreanUnknownChar) {
        splitArr = koreanSplitArr;
    }
    else {
        splitArr = split.map((char) => {
            return {
                char_set_name: const_1.CHAR_TYPE.unknown,
                char
            };
        });
    }
    const unknownChar = splitArr.find((item) => {
        return item.char_set_name === const_1.CHAR_TYPE.unknown;
    });
    if (!unknownChar) {
        const charList = {};
        if (!englishUnknownChar) {
            charList.en = englishSplitArr;
        }
        if (!turkishUnknownChar) {
            charList.tr = turkishSplitArr;
        }
        if (!vietnameseUnknownChar) {
            charList.vi = vietnameseSplitArr;
        }
        if (!thaiUnknownChar) {
            charList.th = thaiSplitArr;
        }
        if (!koreanUnknownChar) {
            charList.ko = koreanSplitArr;
        }
        if (/^en/i.test(language)) {
            language = 'en';
        }
        else if (/^ja/i.test(language)) {
            language = 'ja';
        }
        else if (/^ru/i.test(language)) {
            language = 'ru';
        }
        else if (/^tr/i.test(language)) {
            language = 'tr';
        }
        else if (/^vi/i.test(language)) {
            language = 'vi';
        }
        else if (/^th/i.test(language)) {
            language = 'th';
        }
        else if (/^ko/i.test(language)) {
            language = 'ko';
        }
        if (charList[language]) {
            splitArr = charList[language];
        }
        else if (charList.en) {
            splitArr = charList.en;
        }
    }
    if (addSuffix) {
        const_1.ACCOUNT_SUFFIX.split('')
            .forEach((char) => {
            splitArr.push({
                char_set_name: const_1.CHAR_TYPE.english,
                char
            });
        });
    }
    return splitArr;
}
exports.graphemesAccount = graphemesAccount;
function getAccountCharsetTypes(account) {
    const name = trimAccountSuffix(account);
    const graphemes = graphemesAccount(name);
    const charTypes = {};
    graphemes.forEach(grapheme => {
        charTypes[grapheme.char_set_name] = true;
    });
    return charTypes;
}
exports.getAccountCharsetTypes = getAccountCharsetTypes;
//# sourceMappingURL=account.js.map